import Icon from 'components/atoms/Icon';
import { companyRoutes } from 'constants/navigation';
import { CompaniesPageCompanyFragment } from 'generated/graphql';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Grid, Paper } from '@mui/material';
import useCompaniesStyle from '../CompaniesStyle';
import styles from './CompaniesList.module.scss';

interface ICompaniesList {
  companies: CompaniesPageCompanyFragment[];
}

const CompaniesList: FC<ICompaniesList> = ({ companies }) => {
  const classes = useCompaniesStyle();

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={4}
      className={classes.container}
    >
      <Grid item>
        <Link to={companyRoutes.createCompany.url()}>
          <Paper elevation={3} className={classes.createCompanyPaper}>
            <AddCircleIcon color="primary" fontSize="large" />
          </Paper>
        </Link>
      </Grid>
      {companies.map(company => {
        return (
          <Grid key={company.id} item>
            <Link to={companyRoutes.editCompany.url(company.id)}>
              <Paper elevation={3} className={classes.paper}>
                <div className={classes.companyLogoWrapper}>
                  {company?.logoUrl ? (
                    <img
                      className={classes.companyLogo}
                      src={company.logoUrl}
                      alt="company logo test"
                    />
                  ) : (
                    <Icon
                      icon="empty_company"
                      className={styles.emptyCompanyLogo}
                    />
                  )}
                </div>
                <div className={classes.companyName}>{company.name}</div>
              </Paper>
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CompaniesList;
